import { Route, Routes } from 'react-router-dom'

import List from './screens/List/List'
import FieldMapping from './screens/FieldMapping/FieldMapping'

const CanvaTemplatesRoutes = () => (
  <Routes>
    <Route path="/" element={<List />} />
    <Route path="/field_mapping" element={<FieldMapping />} />
  </Routes>
)

export default CanvaTemplatesRoutes
